import styled from 'styled-components';

export const SectionTitle = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const UserList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-bottom: 16px;
	max-height: 400px;
	overflow-y: auto;
	padding-right: 8px;

	&::-webkit-scrollbar {
		width: 8px;
	}

	&::-webkit-scrollbar-track {
		background: ${({ theme }) => theme.gray[100]};
		border-radius: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background: ${({ theme }) => theme.gray[400]};
		border-radius: 4px;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: ${({ theme }) => theme.gray[600]};
	}
`;

export const UserItem = styled.div`
	font-size: 13px;
	color: ${({ theme }) => theme.gray[1000]};
	padding: 6px 8px;
	background-color: ${({ theme }) => theme.gray[200]};
	border-radius: 4px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-shrink: 0;
	height: 36px;
	box-sizing: border-box;
	user-select: text;
`;

interface RemoveButtonProps {
	disabled: boolean;
}
export const RemoveButton = styled.button<RemoveButtonProps>`
	background-color: transparent;
	color: ${({ theme }) => theme.red[500]};
	border: none;
	border-radius: 4px;
	padding: 0px;
	font-size: 13px;
	width: 60px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 500;
	letter-spacing: 0.02em;
	user-select: none;

	&:hover {
		background-color: ${({ theme, disabled }) => (disabled ? 'transparent' : theme.gray[100])};
	}
`;

export const LoadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	padding: 24px;
`;

export const LoadingText = styled.p`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const AddUserSection = styled.div`
	display: flex;
	gap: 8px;
	width: 100%;
`;

export const EmailInput = styled.input`
	flex: 1;
	min-width: 0;
	padding: 8px;
	border: 1px solid ${({ theme }) => theme.gray[400]};
	border-radius: 4px;
	font-size: 14px;
	color: ${({ theme }) => theme.gray[1000]};
	background-color: ${({ theme }) => theme.gray[100]};

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.gray[700]};
	}
`;

export const AddButton = styled.button`
	background-color: ${({ theme }) => theme.gray[400]};
	color: ${({ theme }) => theme.gray[1000]};
	border: none;
	border-radius: 4px;
	font-size: 14px;
	cursor: pointer;
	transition: background-color 0.2s;
	width: 60px;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		background-color: ${({ theme }) => theme.gray[600]};
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

export const Divider = styled.div`
	height: 1px;
	background-color: ${({ theme }) => theme.gray[200]};
	margin-top: 8px;
	margin-bottom: 16px;
`;
